let React =              require("react");

let Utility =            require("../../util/Utilities.js");

let LoadingPlaceholder = require("../cards/LoadingPlaceholder.jsx");

class ContainsOrUsed extends React.Component {

    constructor(){
        super();
    }

    getIcon(type){
        switch(type){
            case "component":
                return  <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><use xlinkHref='#component' className="icon" /></svg>
            case "symbol":
                return  <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg"><use xlinkHref='#symbol' className="icon" /></svg>
            case "package":
                return  <svg width="25" height="20" xmlns="http://www.w3.org/2000/svg"><use xlinkHref='#package' className="icon" /></svg>
            default:
                return  <svg width="18" height="20" xmlns="http://www.w3.org/2000/svg"><use xlinkHref='#fooprint' className="icon" /></svg>
        }
    }

    render() {
        let {id, type, name, summary} = this.props;
        
        summary = Utility.formatDescription(summary) || "No summary";

        if(name){
            return  <div className="detailsElementPreview__contains__details" onClick={() => this.props.showItem({id, type})}>
                    <div className="icon">{this.getIcon(type)}</div> 
                    <div className="name">{name}</div>
                    <div className="summary">{summary}</div>
                </div>
        }else{
            return <LoadingPlaceholder/>
        }
    }
};

module.exports = ContainsOrUsed;
